import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Button, Form, Modal } from "antd";

import Swal from "sweetalert2";

import partnersApi from "../../apis/Partners.api";
import { setLoading } from "../../redux/store/common/commonDuck";
import { toastAlert } from "../AlertComponent";

import HotKeywordComponent from "./category/HotKeywordComponent";

const EditHotKeyword = ({ channelInfo, getInfo, user }) => {
	const dispatch = useDispatch();
	const isLoading = useSelector((state) => state.common.loading);
	const setIsLoading = (value) => dispatch(setLoading(value));

	const [ingredientList, setIngredientList] = useState([]);
	const [functionList, setFunctionList] = useState([]);
	const [combinationList, setCombinationList] = useState([]);

	const [categoryList, setCategoryList] = useState([[], [], []]);
	const [keywordList, setKeywordList] = useState([
		{ sort_order: 1 },
		{ sort_order: 2 },
		{ sort_order: 3 },
	]);

	const [exampleModal, setExampleModal] = useState(false);
	const [example, setExample] = useState("");

	// useEffect(() => {
	//     console.log(channelInfo?.topSearchedList);
	//     console.log(keywordList);
	//     for (let i = 0; i < keywordList.length; i++) {
	//
	//     }
	// }, [keywordList])

	useEffect(() => {
		getCategoryList();
		if (channelInfo?.topSearchedList) {
			if (channelInfo?.topSearchedList.length >= 3) {
				setKeywordList(channelInfo?.topSearchedList);
			} else if (channelInfo?.topSearchedList.length === 2) {
				// 해당 경우는 거의 발생 X
				setKeywordList([...channelInfo.topSearchedList, { sort_order: 3 }]);
			} else if (channelInfo?.topSearchedList.length === 1) {
				// 해당 경우는 거의 발생 X
				setKeywordList([
					...channelInfo.topSearchedList,
					{ sort_order: 2 },
					{ sort_order: 3 },
				]);
			} else {
				setKeywordList([
					{ sort_order: 1 },
					{ sort_order: 2 },
					{ sort_order: 3 },
				]);
			}
		}
	}, [channelInfo]);

	useEffect(() => {
		let list = [...keywordList];
		let categories = [...categoryList];
		for (let i = 0; i < list.length; i++) {
			if (list[i]?.main_category !== null) {
				let main = list[i].main_category;
				let setCategory = [];
				if (main === 0) {
					setCategory = ingredientList.map((item) => ({
						id: item.id,
						category_id: item.ingredient_id,
						category_name: item.ingredient_name,
						type: "ingredient",
					}));
					categories[i] = setCategory;
				} else if (main === 1) {
					setCategory = functionList.map((item) => ({
						id: item.id,
						category_id: item.function_id,
						category_name: item.function_name,
						type: "function",
					}));
					categories[i] = setCategory;
				} else if (main === 2) {
					setCategory = combinationList.map((item) => ({
						id: item.id,
						category_id: item?.category_id,
						category_name: item.category_name,
						type: "combination",
					}));
					categories[i] = setCategory;
				}
			}
		}
		setCategoryList(categories);
	}, [keywordList, ingredientList, functionList, combinationList]);

	/**
	 * 카테고리 리스트 가져오기
	 * @returns {Promise<void>}
	 */
	const getCategoryList = async () => {
		setIsLoading(true);
		let param = {
			influencerId:
				user?.role === "level_1" || user?.role === "super_admin"
					? user?.id
					: user?.partners_id,
		};

		const res = await partnersApi.readCategoryList(param);
		const rsq = await partnersApi.readCombinationList(param);
		if (res.code === 200 && rsq.code === 200) {
			setIngredientList(res.result.totalIngredientList);
			setFunctionList(res.result.functionList);
			setCombinationList(rsq.result);
		}
		setIsLoading(false);
	};

	/**
	 * 인기검색어 등록/수정
	 * @returns {Promise<void>}
	 */
	const submitHotKeyword = async () => {
		let isValid = false;
		if (keywordList?.length !== 3) {
			toastAlert("인기검색어를 모두 작성해주세요.");
		} else {
			for (let i = 0; i < 3; i++) {
				if (
					typeof keywordList[i].main_category !== "number" ||
					typeof keywordList[i].sub_category !== "number" ||
					keywordList[i].display_word?.length === 0
				) {
					if (!isValid) {
						isValid = true;
					}
				}
			}
			if (isValid) {
				toastAlert("모든 항목을 정확하게 작성/선택해주세요.");
			} else {
				let param = {
					topSearchedList: [
						...keywordList.map((item) => ({
							id: item?.id, // 수정
							sort_order: item?.sort_order, // 등록
							main_category: item?.main_category,
							sub_category: item?.sub_category,
							display_word: item?.display_word,
						})),
					],
					influencer_id: user?.id,
					updated_by: user?.id,
				};

				const res = await partnersApi.postTopKeyword(param);
				if (res.code === 200) {
					Swal.fire({
						customClass: "alert-custom",
						text: "성공적으로 적용되었습니다!",
						confirmButtonText: "확인",
					}).then(() => {
						getInfo();
					});
				} else {
					Swal.fire({
						customClass: "alert-custom",
						text: "error: 적용이 실패되었습니다.",
						confirmButtonText: "확인",
					}).then(() => {});
				}
			}
		}
	};

	return (
		<div style={{ display: "flex", flexDirection: "column" }}>
			<div
				className={`edit-profile-channel`}
				style={{
					alignItems: "flex-start",
				}}
			>
				{/* 인기검색어 관리 */}
				<div className={`edit-channel-component`}>
					<Form>
						<div className={`form-title`}>
							<p className={`title`}>인기검색어 관리</p>
							<p
								className={`example`}
								onClick={() => {
									setExampleModal(true);
									setExample("keyword");
								}}
							>
								예시
							</p>
						</div>
						<div className={`edit-channel-component-body`}>
							<div className={`hot-keyword-form-div`}>
								{keywordList?.map((item, idx) => (
									<div
										className={`hot-keyword-form-each`}
										key={`hot-keyword-${idx}`}
									>
										<HotKeywordComponent
											idx={idx}
											keywordList={keywordList}
											setKeywordList={setKeywordList}
											categoryList={categoryList}
											setCategoryList={setCategoryList}
										/>
									</div>
								))}
							</div>
						</div>
					</Form>
				</div>
			</div>

			<Button
				size={"small"}
				className={`edit-success-btn`}
				style={{
					// borderRadius: "5px",
					// width: "50%",
					margin: "1em auto",
					padding: "0.3em 1.5em",
					height: "auto",
				}}
				loading={isLoading}
				onClick={submitHotKeyword}
			>
				적용하기
			</Button>

			<Modal
				title="인기검색어 예시"
				wrapClassName="sms-send-modal"
				open={exampleModal}
				centered={true}
				onCancel={() => {
					setExampleModal(!exampleModal);
				}}
				width="60%"
				footer={null}
				style={{
					maxWidth: 900,
				}}
			>
				<img
					src={`/assets/images/landing/${example}.jpg`}
					alt={`예시 모달`}
					style={{
						height: "auto",
						width: "100%",
					}}
				/>
			</Modal>
		</div>
	);
};
export default EditHotKeyword;
